<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Jabatan" @back="back">
            
        </a-page-header>

        <a-row type="flex" style="margin-bottom: 12px">
            <a-col  style="padding-left: 12px" flex="1 1 200px">
            </a-col>
            <a-col flex="0 1 300px">
                <a-button type="primary" icon="plus" block @click="showModal('')">
                Tambah
                </a-button>
            </a-col>
        </a-row>

        <a-card type="inner" size="small" >
            <a-table
                class="pcp-table"
                :columns="columns"
                :dataSource="items.data"
                rowKey="id"
                :pagination="false"
                :loading="loading"
                bordered>

                <div slot="name" slot-scope="record" style="text-align: left">
                    {{ record.name }}
                </div>

                <div slot="code" slot-scope="record" style="text-align: left">
                    {{ record.position_code }}
                </div>    

                <div slot="branch" slot-scope="record" style="text-align: left">
                    <div v-if="record.branch != null">
                        {{ record.branch.name }}
                    </div>
                </div>      

                <div slot="updated_at" slot-scope="record" class="text-center">
                    <template v-if="record.updated_at != null">
                        {{ moment(record.updated_at).format('DD-MM-YYYY HH:mm:ss') }}
                    </template>
                </div>

                <div slot="action" slot-scope="record" style="text-align: center">
                    <a-tooltip title="Edit Jabatan">
                        <a-button
                            size="small"
                            type="primary"
                            icon="edit"
                            @click="showModal(record.id, record.name, record.position_code, record.branch != null ? record.branch.hash : '')"
                        />
                    </a-tooltip>
                </div>
            </a-table>
        </a-card>

        <a-modal
            :destroyOnClose="true"
            :footer="null"
            :visible="visible"
            :closable="false"
        >
            <admin-setting-position-form
                :hash="hash"
                :bank="bank"
                :division="division"
                :position="position"
                :position_code="position_code"
                :branch="branch_id"
                @handleClose="closeModal"
            />
        </a-modal>
    </div>
</template>

<script>

const columns = [
    {
		key: 'name',
		title: 'Jabatan',
        align: 'center',
		scopedSlots: {customRender: 'name'},
	}, {
		key: 'code',
		title: 'Kode',
        align: 'center',
		scopedSlots: {customRender: 'code'}
	}, {
		key: 'branch',
		title: 'Cabang',
        align: 'center',
		scopedSlots: {customRender: 'branch'}
	},  {
        key: 'updated_at',
        title: 'Last Update',
        align: 'center',
        scopedSlots: {customRender: 'updated_at'}
    }, 
    // {
	// 	key: 'action',
	// 	title: 'Action',
	// 	align: 'center',
	// 	scopedSlots: {customRender: 'action'}
	// }
]

export default {
    props: {
        branch: {
            type: String,
            default: ''
        },
        division: {
            type: String,
            default: ''
        },
        bank: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            columns,
            loading: false,
            items: {
                data: []
            },
            filters: {
                q: null,
                branch: this.branch,
                division: this.division
            },
            hash: null,
            position: '',
            position_code: '',
            branch_id: '',
            visible: false,
        }
    },
    created() {
        this.getItems()
    },
    methods: {
        getItems() {
            this.loading = true;
            this.$http
                .get(this.routeUri('api.bank-position'), {
                    params: this.filters
                })
                .then(response => this.items = response.data.positions)
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false));
        },
        showModal(hash, name, code, branch) {
            this.hash = hash.toString();
            this.position = name;
            this.position_code = code;
            this.branch_id = branch
            this.visible = true;
        },
        closeModal(isRefresh) {
            this.visible = false;
            this.hash = null;
            this.position = '';
            this.position_code = '';
            this.branch_id = ''

            if (isRefresh == true) {
                this.getItems();
            }
        },
        back(){
            window.history.back()
        }
    },
}
</script>
